// utils/v3/cartKey.ts — cart line identity (SPEC §6)
// Exact port of legacy `store-legacy/cartItems.ts:_buildOptions2`
// and `utils/utilItems.ts:utilsItemGenKeyInCart` (lines 13-22).
import type { CartOptionSelection } from '~/types/v3/cart'
import type { OptionGroup } from '~/types/v3/entities'

export interface CartKeyInput {
  productId: string
  price: number | string
  comments?: string | null
}

/** Flatten every option item with a truthy qty into copies (spread), in group order. */
export function buildOptions2(
  optionsGroupList: readonly OptionGroup[] | null | undefined
): CartOptionSelection[] {
  const options2: CartOptionSelection[] = []
  if (!optionsGroupList) return options2

  for (let index = 0; index < optionsGroupList.length; index++) {
    const optionsGroup = optionsGroupList[index]
    if (optionsGroup?.items) {
      for (const option of optionsGroup.items) {
        if (option?.qty) options2.push({ ...option } as CartOptionSelection)
      }
    }
  }
  return options2
}

/**
 * `${productId}:${comments}:${price}:${opt.productId}x${opt.qty||1}:...`
 * qty is part of the key: the same topping picked x1 and x2 are different lines.
 * Legacy passes the (possibly empty) array from buildOptions2, so an empty array
 * still appends the separating colon — kept byte-identical on purpose.
 */
export function cartKey(
  item: CartKeyInput,
  options2: readonly CartOptionSelection[] | null = null
): string {
  if (options2) {
    const options = options2.map((i) => `${i.productId}x${i.qty || 1}`)
    return `${item.productId}:${item.comments}:${item.price}:${options.join(':')}`
  }
  return `${item.productId}:${item.comments}:${item.price}`
}
